var render = function render(){var _vm=this,_c=_vm._self._c;return _c('search-view',{staticClass:"customer-search-view",attrs:{"value":_vm.$attrs.value,"label":_vm.$attrs.label,"search":_vm.search,"mapName":_vm.mapName,"mapId":_vm.mapId,"read":_vm.read,"create":_vm.create},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }